// extracted by mini-css-extract-plugin
export default {"github":"GitHub_github__ZMLmj","on":"GitHub_on__3xrfb","light":"GitHub_light__Hh1NT"};